import { Platform } from "@linkfluence/models/platform";
import { WizardCorpora } from "@radarly/models/corpora";

export interface InstagramWizardAccount {
  platform: "instagram";
  screenName: string;
}

export interface WebsiteWizardAccount {
  platform: "website";
  screenName: string;
}

export interface FacebookWizardAccount {
  platform: "facebook";
  screenName: string;
}

export interface TwitterWizardAccount {
  platform: "twitter";
  screenName: string;
}

export interface YoutubeWizardAccount {
  platform: "youtube";
  screenName: string;
}

export interface SinaweiboWizardAccount {
  platform: "sinaweibo";
  screenName: string;
}

export interface DouyinWizardAccount {
  platform: "douyin";
  userId: string;
  screenName: string;
}

export interface TikTokWizardAccount {
  platform: "tiktok";
  screenName: string;
}

interface PinterestWizardAccount {
  platform: "pinterest";
  screenName: string;
}

interface RedditWizardAccount {
  platform: "reddit";
  screenName: string;
}

interface TwitchWizardAccount {
  platform: "twitch";
  screenName: string;
}

interface YoukuWizardAccount {
  platform: "youku";
  name: string;
  userId: string;
  screenName: string;
}

export type WizardAccount =
  | InstagramWizardAccount
  | FacebookWizardAccount
  | TwitterWizardAccount
  | YoutubeWizardAccount
  | SinaweiboWizardAccount
  | DouyinWizardAccount
  | TikTokWizardAccount
  | YoukuWizardAccount
  | PinterestWizardAccount
  | TwitchWizardAccount
  | RedditWizardAccount
  | WebsiteWizardAccount;

export interface MeAccount {
  label: string;
  platform: Platform;
}

export type AccountModal = "owned" | "influencers";

export type AccountSubModal = "main" | "social_accounts" | "corpus" | "me";

export const PLATFORMS = [
  Platform.Facebook,
  Platform.Instagram,
  // Platform.Pinterest,
  // Platform.Tiktok,
  Platform.Twitter,
  // Platform.Twitch,
  // Platform.Reddit,
  Platform.Website,
];

export type WizardInputPlatform = typeof PLATFORMS[number];

export type WizardTotalCorpusesSources = {
  [corpusName: string]: { [platform: string]: number };
};

export type CorporaSelection = {
  [corpusName: string]: WizardCorpora;
};
